import styled from 'styled-components'

const TableBox = styled.div`
  div:first-child {
    white-space: unset;
    text-overflow: ellipsis;
  }
  // .ifOHjV{
  //   position: fixed;
  // }

  .sc-dmRaPn {
    position: relative;
    width: 100%;
    border-radius: inherit;
    overflow-x: auto;
    overflow-y: auto;
    min-height: 0;
  }
  .sc-hHLeRK {
    min-height: 450px;
  }

  .rdt_TableCell:nth-of-type(2) {
    text-transform: capitalize;
  }
`
const RadioBox = styled.div`
  .form-check .form-check-input {
    float: left;
    margin-left: 0;
  }
`

const SwitchBox = styled.div`
  .form-check-input[type='checkbox'][role='switch'] {
    width: 48px;
    height: 26px;
    border-radius: 13px;
    border: none;
    cursor: pointer;
    appearance: none;
    -webkit-appearance: none;
    background-color: #d6f0d6;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
    background-position: left 0px center;
    background-repeat: no-repeat;
    background-size: 25px 25px;
    transition: background-color 0.2s ease-in-out, background-position 0.2s ease-in-out;
    box-shadow: none;
    outline: none;
  }

  .form-check-input[type='checkbox'][role='switch']:checked {
    background-color: #4caf50;
    background-position: right 1px center;
  }

  .form-check-input[type='checkbox'][role='switch']:focus {
    box-shadow: none;
    outline: none;
  }
`

export { TableBox, RadioBox, SwitchBox }
